module.exports = __webpack_public_path__ + "static/img/bg.3bb75024.png";